import { render, staticRenderFns } from "./SmsNew.vue?vue&type=template&id=fdf89236"
import script from "./SmsNew.vue?vue&type=script&lang=js"
export * from "./SmsNew.vue?vue&type=script&lang=js"
import style0 from "./SmsNew.vue?vue&type=style&index=0&id=fdf89236&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports